import {BIG_BROTHER_EVENTS} from './constants';


class BigBrotherAnalytics {
  mapObjectDataToJSONData (data, event) {
      let payload = {};
      if (data) {
        payload = {
          'ad_id' : data.job ? data.job.id : '',
          'cat_id' : '93',
          'cat_name' : 'Jobs',
          'city_id' : data.job ? data.job.cityId : data.cityId ? data.cityId : '1' ,
          'city_name' : data.job ? data.job.cityName : data.city ? data.city : 'www',
          'event_name' : event,
          'event_time_epoc_ms' : (new Date).getTime()
        };
      }
      if (data.papSuccess) {
        payload.subcat_name = data.subcatname ? data.subcatname : "";
        payload.role = data.role ? data.role : "";
      }
      if (event == BIG_BROTHER_EVENTS.jobsVapLoad) {
        payload.subcat_name = data.job ? data.job.role : data.role ? data.role : "";
      }
      if (event == BIG_BROTHER_EVENTS.jobsSnBFilterSelect) {
        payload.filter_select = data.filterSelect ? data.filterSelect : "";
      }
      if (event == 'Browse') {
        payload.subcat_name = data.jobtype && data.jobtype.length > 0
          ? data.jobtype.join(',')
          : data.role
            ? data.role
            : "";
        payload.role = data.role ? data.role : "";
      }
      if (event == "Search") {
        payload.subcat_name = data.jobtype && data.jobtype.length > 0
          ? data.jobtype.join(',')
          : "";
        payload.properties = {
          keyword: data.keyword ? data.keyword : ""
        }
      }

      this._pushDataToBigBrotherAnalytics(payload, event);
  }

  _pushDataToBigBrotherAnalytics (payload, event) {
    const MAX_TRY = 10; // try 10 times
    const pushEvent = (event, payload, tryCount = MAX_TRY) => {
      try {
        if (typeof _paqv3 !== 'undefined' && _paqv3) {
          _paqv3.push(['_sendEventApiData', event, 'PWA', JSON.stringify(payload)]);
        } else if(tryCount) {
          setTimeout(() => pushEvent(event, payload, tryCount - 1), 1000);
        }
      } catch(e) {
        console.log('bigBrother push error', e);
      }
    };
    pushEvent(event, payload, MAX_TRY);
  }
}

export default new BigBrotherAnalytics();



// WEBPACK FOOTER //
// ../q-jobs/src/utils/BigBrotherAnalytics/index.js